/**
 * Swiper 초기화 정책
 ├─ GEO01: HTML 직후 바로 초기화
 ├─ GEO03: document ready에서 초기화
 └─ GEO05~14
      ├─ 브라우저 유휴 시점에 감시 시작
      └─ 화면 400px 근처에 오면 해당 GEO만 초기화
 *
 * 외부 데이터 연동 포인트
 * - 카테고리 변경 이벤트는 해당 섹션에서 발생하며 두 번째 인자는 { category: string }이다.
 *   careSolutions:resubscribeCategoryChange
 *   careSolutions:bestRankingCategoryChange
 *   careSolutions:personalizedRecommendationCategoryChange
 *   careSolutions:subscriptionGuideCategoryChange
 *   careSolutions:faqCategoryChange
 * - 목록 DOM 갱신 후 Swiper 재초기화가 필요하면 아래 공개 메서드를 사용한다.
 *   subscriptionHomeUI.reinitSwiper('js-home-...');
 *   subscriptionHomeUI.reinitAllSwipers();
 */
var subscriptionHomeUI = {
  swipers: {}, // 생성된 Swiper 인스턴스 보관
  deferredSwiperGroups: {}, // [지연] GEO별 Swiper 활성화 여부
  deferredSwiperObserver: null, // [지연] 화면 접근 감지 Observer
  isDeferredSwiperScheduled: false, // [지연] 감시 예약 중복 방지
  isSwiperResizeBound: false, // Swiper 리사이즈 이벤트 중복 등록 방지
  activeDialogTrigger: null, // 다이얼로그 종료 후 포커스를 돌려줄 요소

  init: function() {
    this.initFAQAccessibility();
    this.initSwipers();
    this.initLayoutToggles();
    this.initTabSwitchers();
    this.initPersonalizedRecommendationSticky();
    this.initTabOverflow();
    this.initResubscribeTooltip();
    this.initDialogs();
  },

  // GEO 06. [접근성] 모바일 재구독 할인 대상 툴팁 상태를 버튼과 동기화한다.
  initResubscribeTooltip: function() {
    var buttonSelector = '.js-home-resubscribe-tooltip-button';
    var closeSelector = '.js-home-resubscribe-tooltip-close';
    var tooltipSelector = '.js-home-resubscribe-tooltip';
    var $button = $(buttonSelector);
    var $tooltip = $(tooltipSelector);

    if (!$button.length || !$tooltip.length) return;

    function setTooltipState(isOpen) {
      var shouldOpen = Boolean(isOpen);

      $button.attr({
        'aria-expanded': shouldOpen ? 'true' : 'false',
        'aria-label': shouldOpen
          ? '재구독 할인 대상 기간 안내 닫기'
          : '재구독 할인 대상 기간 안내 보기'
      });
      $tooltip
        .toggleClass('is-open', shouldOpen)
        .prop('hidden', !shouldOpen)
        .attr('aria-hidden', shouldOpen ? 'false' : 'true');
    }

    setTooltipState(false);

    $(document)
      .off('click.homeResubscribeTooltip', buttonSelector)
      .on('click.homeResubscribeTooltip', buttonSelector, function() {
        setTooltipState($(this).attr('aria-expanded') !== 'true');
      });

    $(document)
      .off('click.homeResubscribeTooltipClose', closeSelector)
      .on('click.homeResubscribeTooltipClose', closeSelector, function() {
        setTooltipState(false);
        $button.first().trigger('focus');
      });

    $(document)
      .off('click.homeResubscribeTooltipOutside')
      .on('click.homeResubscribeTooltipOutside', function(event) {
        if ($(event.target).closest(buttonSelector + ', ' + tooltipSelector).length) return;
        setTooltipState(false);
      });

    $(document)
      .off('keydown.homeResubscribeTooltip')
      .on('keydown.homeResubscribeTooltip', function(event) {
        if ((event.key !== 'Escape' && event.keyCode !== 27) || $button.attr('aria-expanded') !== 'true') return;

        event.preventDefault();
        setTooltipState(false);
        $button.first().trigger('focus');
      });
  },

  // GEO 13. [접근성] FAQ 답변 DOM을 유지하며 아코디언 상태를 연결한다.
  initFAQAccessibility: function() {
    $('.js-home-faq-item').each(function(index) {
      var $item = $(this);
      var $question = $item.find('.js-home-faq-question');
      var $answer = $item.find('.js-home-faq-answer');
      var questionId = 'faq-question-' + (index + 1);
      var answerId = 'faq-answer-' + (index + 1);

      $question.attr({
        id: questionId,
        'aria-controls': answerId,
        'aria-expanded': $item.hasClass('is-open') ? 'true' : 'false'
      });
      $answer.attr({
        id: answerId,
        role: 'region',
        'aria-labelledby': questionId,
        'aria-hidden': $item.hasClass('is-open') ? 'false' : 'true'
      });

      if ($item.hasClass('is-open')) {
        $answer.css('max-height', $answer[0].scrollHeight + 'px');
      }
    });

    var self = this;
    $(window).off('resize.homeFaq').on('resize.homeFaq', function() {
      self.syncOpenFAQAnswers($('.js-home-faq-panel'));
    });

    if (document.fonts && document.fonts.ready) {
      document.fonts.ready.then(function() {
        self.syncOpenFAQAnswers($('.js-home-faq-panel'));
      });
    }
  },

  syncOpenFAQAnswers: function($scope) {
    $scope.find('.js-home-faq-item.is-open .js-home-faq-answer').each(function() {
      this.style.maxHeight = this.scrollHeight + 'px';
    });
  },

  // GEO 10. [접근성] 모바일에서 현재 보이는 방문케어 카드의 버튼만 키보드로 접근한다.
  syncExpertCareSlideState: function(swiper) {
    var $slides = $('.js-home-expert-care-swiper .careSolutions__expert-care-highlight-item');
    var isMobileSwiper = window.innerWidth < 1024 && swiper;

    $slides.each(function(index) {
      var $slide = $(this);
      var isActive = !isMobileSwiper || index === swiper.activeIndex;

      if (isMobileSwiper) {
        $slide.attr('aria-hidden', isActive ? 'false' : 'true');
      } else {
        $slide.removeAttr('aria-hidden');
      }

      if (isActive) {
        $slide.find('.careSolutions__expert-care-highlight-video').removeAttr('tabindex');
      } else {
        $slide.find('.careSolutions__expert-care-highlight-video').attr('tabindex', '-1');
      }
    });
  },

  // GEO 12. [접근성] 현재 화면에 보이는 구독 가이드 카드 링크만 키보드로 접근한다.
  syncSubscriptionGuideSlideState: function(swiper) {
    if (!swiper) return;

    $(swiper.slides).each(function() {
      var $slide = $(this);
      var isVisible = $slide.hasClass('swiper-slide-visible');

      $slide.attr('aria-hidden', isVisible ? 'false' : 'true');

      if (isVisible) {
        $slide.find('a, button').removeAttr('tabindex');
      } else {
        $slide.find('a, button').attr('tabindex', '-1');
      }
    });
  },

  // GEO 10·11. 영상/상품 확인 모달과 MO 바텀시트 동작
  initDialogs: function() {
    var self = this;
    var $videoDialog = $('.js-home-video-dialog');
    var $cartDialog = $('.js-home-cart-dialog');

    $(document).on('click.homeDialogs', '.careSolutions__expert-care-highlight-video', function() {
      var $button = $(this);
      var buttonText = $.trim($button.text());
      var videoLabel = ' 케어 과정 영상으로 보기';
      var categoryName = buttonText.slice(-videoLabel.length) === videoLabel
        ? buttonText.slice(0, -videoLabel.length)
        : buttonText;
      var title = $button.attr('data-video-title') || categoryName + ' 케어 서비스';
      var description = $button.attr('data-video-description') || categoryName + ' 전문 케어 매니저의 방문케어 과정과 주요 관리 내용을 영상으로 확인해 보세요.';
      var videoSrc = $button.attr('data-video-src');
      var videoPoster = $button.attr('data-video-poster');
      var video = $videoDialog.find('.js-home-care-video')[0];

      $videoDialog.find('.js-home-video-dialog-title').text(title);
      $videoDialog.find('.js-home-video-description-text').text(description);
      self.resetVideoDialog($videoDialog);

      if (video) {
        var $video = $(video);
        var $source = $video.find('source').first();

        if (videoPoster) {
          $video.attr('poster', videoPoster);
        } else {
          $video.removeAttr('poster');
        }

        if (videoSrc && $source.attr('src') !== videoSrc) {
          $source.attr('src', videoSrc);
          video.load();
        }
      }

      self.openDialog($videoDialog, $button);

      if (video) {
        video.muted = false;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function() {
            self.syncCareVideoControls(video);
          });
        }
      }
    });

    $(document).on('click.homeDialogs', '.js-home-care-video-play', function() {
      var video = $(this).closest('.js-home-video-dialog').find('.js-home-care-video')[0];
      if (!video) return;

      if (video.paused || video.ended) {
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function() {});
        }
      } else {
        video.pause();
      }
    });

    $videoDialog.find('.js-home-care-video').on('play pause ended', function() {
      self.syncCareVideoControls(this);
    });

    $(document).on('click.homeDialogs', '.js-home-video-description-toggle', function() {
      var $toggle = $(this);
      var $description = $toggle.closest('.js-home-video-dialog').find('.js-home-video-description');
      var isExpanded = $toggle.attr('aria-expanded') === 'true';

      $toggle
        .toggleClass('is-expanded', !isExpanded)
        .attr('aria-expanded', isExpanded ? 'false' : 'true')
        .find('span')
        .text(isExpanded ? '동영상 설명 보기' : '동영상 설명 닫기');
      $description.prop('hidden', isExpanded);
    });

    $(document).on('click.homeDialogs', '.careSolutions__personalized-recommendation-cart', function() {
      var $button = $(this);

      self.hideCartToast($('.js-home-cart-toast'));
      self.openDialog($cartDialog, $button);
    });

    $(document).on('click.homeDialogs', '.js-home-cart-confirm', function() {
      var $dialog = $(this).closest('.js-home-cart-dialog');

      self.closeDialog($dialog);
    });

    $(document).on('click.homeDialogs', '.js-home-cart-cancel', function() {
      var $dialog = $(this).closest('.js-home-cart-dialog');

      self.closeDialog($dialog);
    });

    $(document).on('click.homeDialogs', '.js-home-dialog-close', function() {
      self.closeDialog($(this).closest('.js-home-dialog'));
    });

    $(document).on('click.homeDialogs', '.js-home-cart-toast-close', function() {
      self.hideCartToast($(this).closest('.js-home-cart-toast'));
    });

    $(document).on('click.homeDialogs', '.careSolutions__cart-toast-link[href="#n"]', function(event) {
      event.preventDefault();
    });

    // GEO 10·11. [접근성] ESC 닫기와 다이얼로그 내부 포커스 순환
    $(document).on('keydown.homeDialogs', function(event) {
      var $openDialog = $('.js-home-dialog.is-open').last();
      if (!$openDialog.length) return;

      if (event.key === 'Escape' || event.keyCode === 27) {
        event.preventDefault();
        self.closeDialog($openDialog);
        return;
      }

      if (event.key !== 'Tab' && event.keyCode !== 9) return;

      var $focusable = $openDialog
        .find('a[href], button:not([disabled]), input:not([disabled]), [tabindex]:not([tabindex="-1"])')
        .filter(':visible');
      if (!$focusable.length) return;

      var first = $focusable[0];
      var last = $focusable[$focusable.length - 1];

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  },

  openDialog: function($dialog, $trigger) {
    if (!$dialog || !$dialog.length) return;

    var $openedDialog = $('.js-home-dialog.is-open').not($dialog);
    if ($openedDialog.length) {
      this.closeDialog($openedDialog, false);
    }

    this.activeDialogTrigger = $trigger && $trigger.length
      ? $trigger[0]
      : document.activeElement;

    $dialog
      .removeAttr('hidden')
      .attr('aria-hidden', 'false')
      .addClass('is-open');
    $('body').addClass('is-care-solutions-dialog-open');

    window.setTimeout(function() {
      var $focusTarget = $dialog.find('.careSolutions__dialog-panel').first();
      if ($focusTarget.length) $focusTarget.trigger('focus');
    }, 0);
  },

  closeDialog: function($dialog, restoreFocus) {
    if (!$dialog || !$dialog.length) return;

    if ($dialog.hasClass('js-home-video-dialog')) {
      this.resetVideoDialog($dialog);
    }

    $dialog
      .removeClass('is-open')
      .attr({ hidden: 'hidden', 'aria-hidden': 'true' });

    if (!$('.js-home-dialog.is-open').length) {
      $('body').removeClass('is-care-solutions-dialog-open');
    }

    if (restoreFocus !== false && this.activeDialogTrigger) {
      this.activeDialogTrigger.focus();
    }
    this.activeDialogTrigger = null;
  },

  resetVideoDialog: function($dialog) {
    var video = $dialog.find('.js-home-care-video')[0];
    var $toggle = $dialog.find('.js-home-video-description-toggle');

    if (video) {
      video.pause();
      try {
        video.currentTime = 0;
      } catch (error) {}
      this.syncCareVideoControls(video);
    }

    $dialog.find('.js-home-video-description').prop('hidden', true);
    $toggle
      .removeClass('is-expanded')
      .attr('aria-expanded', 'false')
      .find('span')
      .text('동영상 설명 보기');
  },

  syncCareVideoControls: function(video) {
    if (!video) return;

    var $dialog = $(video).closest('.js-home-video-dialog');
    var isPlaying = !video.paused && !video.ended;

    $dialog.find('.js-home-care-video-play')
      .toggleClass('is-playing', isPlaying)
      .attr('aria-label', isPlaying ? '동영상 일시정지' : '동영상 재생');
  },

  showCartToast: function($toast) {
    $toast.removeAttr('hidden');
  },

  hideCartToast: function($toast) {
    $toast.attr('hidden', 'hidden');
  },

  // GEO 01. 히어로 배너 - 첫 페인트 전에 우선 초기화
  initHeroSwiper: function() {
    var heroCarouselEl = document.querySelector('.js-home-hero-carousel');
    var heroSectionEl = heroCarouselEl
      ? heroCarouselEl.closest('.js-home-hero')
      : document.querySelector('.js-home-hero');

    if (!heroCarouselEl) return;

    if (this.swipers['js-home-hero-carousel'] || heroCarouselEl.swiper) {
      if (heroSectionEl) heroSectionEl.classList.remove('is-loading');
      return;
    }

    if (typeof Swiper === 'undefined') {
      if (heroSectionEl) heroSectionEl.classList.remove('is-loading');
      return;
    }

    this.swipers['js-home-hero-carousel'] = new Swiper(
      heroCarouselEl,
      this.getSwiperOptions('js-home-hero-carousel')
    );
  },

  // GEO 07. MO 펼침 목록에서는 Swiper를 해제하고, 접힌 목록과 PC에서는 뷰포트별 옵션으로 복원한다.
  destroyCategorySwiper: function(carouselClass) {
    var swiper = this.swipers[carouselClass];

    if (swiper && !swiper.destroyed) {
      swiper.destroy(true, true);
    }
    delete this.swipers[carouselClass];
  },

  syncCategorySwiper: function(carouselClass, carouselEl) {
    if (!carouselEl || typeof Swiper === 'undefined') return null;

    var viewport = window.innerWidth < 1024 ? 'mobile' : 'pc';
    var $container = $(carouselEl).closest(
      '.js-home-best-ranking-tab-container, .js-home-subscription-guide-tab-container'
    );
    var isExpandedMobile = viewport === 'mobile' && $container.hasClass('is-expanded');
    var swiper = this.swipers[carouselClass];

    if (swiper && swiper.destroyed) {
      delete this.swipers[carouselClass];
      swiper = null;
    }

    if (swiper && (swiper.homeCategoryViewport !== viewport || isExpandedMobile)) {
      this.destroyCategorySwiper(carouselClass);
      swiper = null;
    }

    if (isExpandedMobile) return null;

    if (!swiper) {
      swiper = new Swiper(carouselEl, this.getSwiperOptions(carouselClass));
      swiper.homeCategoryViewport = viewport;
      this.swipers[carouselClass] = swiper;
    }

    return swiper;
  },

  // GEO 공통. GEO 01은 페이지에서 선행하고, GEO 03은 즉시, GEO 05~14는 지연 초기화한다.
  initSwipers: function() {
    // GEO 01. 페이지 마크업 직후 호출이 누락된 환경을 위한 안전 재호출
    this.initHeroSwiper();
    if (typeof Swiper === 'undefined') return;

    var self = this;

    // GEO 03. 구독 카테고리 퀵메뉴 - MO freeMode / PC 카테고리 슬라이더
    var categoryQuickMobileCarouselEl = document.querySelector('.js-home-category-quick-mobile-carousel');
    var categoryQuickCarouselEl = document.querySelector('.js-home-category-quick-carousel');

    if (
      categoryQuickMobileCarouselEl &&
      window.innerWidth < 1024 &&
      !self.swipers['js-home-category-quick-mobile-carousel']
    ) {
      self.swipers['js-home-category-quick-mobile-carousel'] = new Swiper(
        categoryQuickMobileCarouselEl,
        self.getSwiperOptions('js-home-category-quick-mobile-carousel')
      );
    } else if (
      categoryQuickCarouselEl &&
      window.innerWidth >= 1024 &&
      !self.swipers['js-home-category-quick-carousel']
    ) {
      self.swipers['js-home-category-quick-carousel'] = new Swiper(
        categoryQuickCarouselEl,
        self.getSwiperOptions('js-home-category-quick-carousel')
      );
    }

    self.scheduleDeferredSwipers();

    if (self.isSwiperResizeBound) return;
    self.isSwiperResizeBound = true;

    // GEO 03·07·10·12. PC/MO 전환 시 Swiper 활성 상태 변경
    window.addEventListener('resize', function() {
      // GEO 03. 구독 카테고리 퀵메뉴 MO/PC Swiper 전환
      var categoryQuickMobileEl = document.querySelector('.js-home-category-quick-mobile-carousel');
      var categoryQuickEl = document.querySelector('.js-home-category-quick-carousel');
      if (window.innerWidth < 1024) {
        if (self.swipers['js-home-category-quick-carousel']) {
          self.swipers['js-home-category-quick-carousel'].destroy(true, true);
          delete self.swipers['js-home-category-quick-carousel'];
        }

        if (categoryQuickMobileEl && !self.swipers['js-home-category-quick-mobile-carousel']) {
          self.swipers['js-home-category-quick-mobile-carousel'] = new Swiper(
            categoryQuickMobileEl,
            self.getSwiperOptions('js-home-category-quick-mobile-carousel')
          );
        }
      } else {
        if (self.swipers['js-home-category-quick-mobile-carousel']) {
          self.swipers['js-home-category-quick-mobile-carousel'].destroy(true, true);
          delete self.swipers['js-home-category-quick-mobile-carousel'];
        }

        if (categoryQuickEl && !self.swipers['js-home-category-quick-carousel']) {
          self.swipers['js-home-category-quick-carousel'] = new Swiper(
            categoryQuickEl,
            self.getSwiperOptions('js-home-category-quick-carousel')
          );
        }
      }

      if (self.deferredSwiperGroups.geo07) {
        // GEO 07. 베스트 랭킹 카테고리는 MO/PC 전환 시 각 전용 옵션으로 재초기화한다.
        var bestRankingCategoriesEl = document.querySelector('.js-home-best-ranking-categories');
        if (bestRankingCategoriesEl) {
          self.syncCategorySwiper('js-home-best-ranking-categories', bestRankingCategoriesEl);
        }

        // GEO 07. 베스트 랭킹 상품은 PC에서만 Swiper로 동작한다.
        var bestRankingProductsEl = document.querySelector('.js-home-best-ranking-products');
        if (window.innerWidth < 1024) {
          if (self.swipers['js-home-best-ranking-products']) {
            self.swipers['js-home-best-ranking-products'].destroy(true, true);
            delete self.swipers['js-home-best-ranking-products'];
          }
        } else if (bestRankingProductsEl && !self.swipers['js-home-best-ranking-products']) {
          self.swipers['js-home-best-ranking-products'] = new Swiper(
            bestRankingProductsEl,
            self.getSwiperOptions('js-home-best-ranking-products')
          );
        }
      }

      if (self.deferredSwiperGroups.geo12) {
        // GEO 12. 구독 가이드 카테고리는 MO/PC 전환 시 각 전용 옵션으로 재초기화한다.
        var subscriptionGuideCategoriesEl = document.querySelector('.js-home-subscription-guide-categories');
        if (subscriptionGuideCategoriesEl) {
          self.syncCategorySwiper('js-home-subscription-guide-categories', subscriptionGuideCategoriesEl);
        }
      }

      if (self.deferredSwiperGroups.geo10) {
        // GEO 10. 전문가 방문케어 카드는 모바일에서만 Swiper로 동작한다.
        var expertCareEl = document.querySelector('.js-home-expert-care-swiper');
        if (window.innerWidth < 1024) {
          if (expertCareEl && !self.swipers['js-home-expert-care-swiper']) {
            self.swipers['js-home-expert-care-swiper'] = new Swiper(
              expertCareEl,
              self.getSwiperOptions('js-home-expert-care-swiper')
            );
          }
        } else if (self.swipers['js-home-expert-care-swiper']) {
          self.swipers['js-home-expert-care-swiper'].destroy(true, true);
          delete self.swipers['js-home-expert-care-swiper'];
          self.syncExpertCareSlideState(null);
        }
      }
    });
  },

  // GEO 05~14. 초기 렌더링과 분리해 유휴 시점부터 지연 초기화 감시를 시작한다.
  scheduleDeferredSwipers: function() {
    if (this.isDeferredSwiperScheduled) return;
    this.isDeferredSwiperScheduled = true;

    var self = this;
    var startObserving = function() {
      self.initDeferredSwipers();
    };

    if (typeof window.requestIdleCallback === 'function') {
      window.requestIdleCallback(startObserving, { timeout: 1500 });
    } else {
      window.setTimeout(startObserving, 200);
    }
  },

  // GEO 05~14. 화면에 가까워진 섹션의 Swiper 기능만 한 번 활성화한다.
  initDeferredSwipers: function() {
    var self = this;
    var groups = [
      { name: 'geo05', selector: '.js-home-subscription-benefit-banner' },
      { name: 'geo06', selector: '.js-home-resubscribe-benefits' },
      { name: 'geo07', selector: '.js-home-best-ranking' },
      { name: 'geo08', selector: '.js-home-season-promotion' },
      { name: 'geo09', selector: '.js-home-subscription-reasons' },
      { name: 'geo10', selector: '.js-home-expert-care-highlight' },
      { name: 'geo12', selector: '.js-home-subscription-guide' }
    ];
    var observedGroups = [];

    groups.forEach(function(group) {
      var target = document.querySelector(group.selector);

      if (!target || self.deferredSwiperGroups[group.name]) return;
      observedGroups.push({ name: group.name, target: target });
    });

    if (!observedGroups.length) return;

    if (typeof window.IntersectionObserver !== 'function') {
      observedGroups.forEach(function(group) {
        self.initDeferredSwiperGroup(group.name);
      });
      return;
    }

    self.deferredSwiperObserver = new IntersectionObserver(function(entries, observer) {
      entries.forEach(function(entry) {
        if (!entry.isIntersecting) return;

        observedGroups.forEach(function(group) {
          if (group.target !== entry.target) return;

          self.initDeferredSwiperGroup(group.name);
          observer.unobserve(entry.target);
        });
      });
    }, {
      rootMargin: '400px 0px',
      threshold: 0
    });

    observedGroups.forEach(function(group) {
      self.deferredSwiperObserver.observe(group.target);
    });
  },

  // GEO 05~14. 섹션 단위 지연 초기화
  initDeferredSwiperGroup: function(groupName) {
    if (this.deferredSwiperGroups[groupName] || typeof Swiper === 'undefined') return;
    this.deferredSwiperGroups[groupName] = true;

    var self = this;
    var swiper;

    if (groupName === 'geo05') {
      var subscriptionBenefitBannerEl = document.querySelector('.js-home-subscription-benefit-banner');
      if (subscriptionBenefitBannerEl && !self.swipers['js-home-subscription-benefit-banner']) {
        self.swipers['js-home-subscription-benefit-banner'] = new Swiper(
          subscriptionBenefitBannerEl,
          self.getSwiperOptions('js-home-subscription-benefit-banner')
        );
      }
      return;
    }

    if (groupName === 'geo06') {
      var resubscribeContractsEl = document.querySelector('.js-home-resubscribe-contracts');
      if (resubscribeContractsEl && !self.swipers['js-home-resubscribe-contracts']) {
        self.swipers['js-home-resubscribe-contracts'] = new Swiper(
          resubscribeContractsEl,
          self.getSwiperOptions('js-home-resubscribe-contracts')
        );
      }

      var resubscribeProductsEl = document.querySelector('.js-home-resubscribe-products');
      if (resubscribeProductsEl && !self.swipers['js-home-resubscribe-products']) {
        self.swipers['js-home-resubscribe-products'] = new Swiper(
          resubscribeProductsEl,
          self.getSwiperOptions('js-home-resubscribe-products')
        );
      }
      return;
    }

    if (groupName === 'geo07') {
      var bestRankingCategoriesEl = document.querySelector('.js-home-best-ranking-categories');
      if (bestRankingCategoriesEl) {
        self.syncCategorySwiper('js-home-best-ranking-categories', bestRankingCategoriesEl);
      }

      var bestRankingProductsEl = document.querySelector('.js-home-best-ranking-products');
      if (
        bestRankingProductsEl &&
        window.innerWidth >= 1024 &&
        !self.swipers['js-home-best-ranking-products']
      ) {
        self.swipers['js-home-best-ranking-products'] = new Swiper(
          bestRankingProductsEl,
          self.getSwiperOptions('js-home-best-ranking-products')
        );
      }
      return;
    }

    if (groupName === 'geo08') {
      var seasonPromotionEls = document.querySelectorAll('.js-home-season-promotion-swiper');
      if (!Array.isArray(self.swipers['js-home-season-promotion-swiper'])) {
        self.swipers['js-home-season-promotion-swiper'] = [];
      }

      Array.prototype.forEach.call(seasonPromotionEls, function(seasonPromotionEl) {
        swiper = seasonPromotionEl.swiper || new Swiper(
          seasonPromotionEl,
          self.getSwiperOptions('js-home-season-promotion-swiper', seasonPromotionEl)
        );

        if (self.swipers['js-home-season-promotion-swiper'].indexOf(swiper) < 0) {
          self.swipers['js-home-season-promotion-swiper'].push(swiper);
        }
      });
      return;
    }

    if (groupName === 'geo09') {
      var subscriptionReasonsEl = document.querySelector('.js-home-subscription-reasons-swiper');
      if (subscriptionReasonsEl && !self.swipers['js-home-subscription-reasons-swiper']) {
        self.swipers['js-home-subscription-reasons-swiper'] = new Swiper(
          subscriptionReasonsEl,
          self.getSwiperOptions('js-home-subscription-reasons-swiper')
        );
      }
      return;
    }

    if (groupName === 'geo10') {
      var expertCareEl = document.querySelector('.js-home-expert-care-swiper');
      if (
        expertCareEl &&
        window.innerWidth < 1024 &&
        !self.swipers['js-home-expert-care-swiper']
      ) {
        self.swipers['js-home-expert-care-swiper'] = new Swiper(
          expertCareEl,
          self.getSwiperOptions('js-home-expert-care-swiper')
        );
      }
      return;
    }

    if (groupName === 'geo12') {
      var subscriptionGuideCategoriesEl = document.querySelector('.js-home-subscription-guide-categories');
      if (subscriptionGuideCategoriesEl) {
        self.syncCategorySwiper('js-home-subscription-guide-categories', subscriptionGuideCategoriesEl);
      }

      var subscriptionGuideEl = document.querySelector('.js-home-subscription-guide-swiper');
      if (subscriptionGuideEl && !self.swipers['js-home-subscription-guide-swiper']) {
        self.swipers['js-home-subscription-guide-swiper'] = new Swiper(
          subscriptionGuideEl,
          self.getSwiperOptions('js-home-subscription-guide-swiper')
        );
      }
    }
  },

  // GEO 공통. Swiper 옵션 구성
  getSwiperOptions: function(carouselClass, carouselEl) {
    var options = {};
    switch (carouselClass) {
      case 'js-home-hero-carousel':
        // GEO 01. 슬라이드가 적으면 초기화 직전에 복제해 PC 양옆 노출을 유지한다.
        var heroEl = document.querySelector('.js-home-hero-carousel');
        var heroSectionEl = heroEl ? heroEl.closest('.js-home-hero') : null;
        var heroWrapper = heroEl ? heroEl.querySelector('.swiper-wrapper') : null;
        var heroClones = heroWrapper
          ? heroWrapper.querySelectorAll('.swiper-slide[data-home-hero-clone]')
          : [];
        var heroCloneIndex;

        for (heroCloneIndex = heroClones.length - 1; heroCloneIndex >= 0; heroCloneIndex -= 1) {
          heroWrapper.removeChild(heroClones[heroCloneIndex]);
        }

        var heroSlides = heroWrapper
          ? heroWrapper.querySelectorAll(':scope > .swiper-slide')
          : [];
        var heroSlideCount = heroSlides.length;

        if (heroSectionEl) {
          heroSectionEl.classList.toggle('is-single', heroSlideCount <= 1);
        }

        // GEO 01. PC 1920에서 노출되는 5개와 centeredSlides의 루프 여유를 확보한다.
        // 일부 슬라이드만 덧붙이면 루프 경계에서 원본 순서가 끊기므로 원본 세트 단위로만 복제한다.
        var heroMinimumLoopSlides = 9;

        for (heroCloneIndex = 0; heroCloneIndex < heroSlideCount; heroCloneIndex += 1) {
          heroSlides[heroCloneIndex].setAttribute('data-home-hero-index', heroCloneIndex);
        }

        if (heroWrapper && heroSlideCount > 1 && heroSlideCount < heroMinimumLoopSlides) {
          var heroLoopSetCount = Math.ceil(heroMinimumLoopSlides / heroSlideCount);
          var heroLoopSetIndex;

          for (heroLoopSetIndex = 1; heroLoopSetIndex < heroLoopSetCount; heroLoopSetIndex += 1) {
            for (heroCloneIndex = 0; heroCloneIndex < heroSlideCount; heroCloneIndex += 1) {
              var heroClone = heroSlides[heroCloneIndex].cloneNode(true);
              heroClone.setAttribute('data-home-hero-clone', 'true');
              heroClone.setAttribute('data-home-hero-index', heroCloneIndex);
              heroWrapper.appendChild(heroClone);
            }
          }
        }

        var heroCanAutoplay = heroSlideCount > 1
          && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        var heroPcMedia = window.matchMedia('(min-width: 1024px)');
        var heroComputedStyle = window.getComputedStyle(heroEl);
        var heroSpaceBetweenMobile = parseFloat(
          heroComputedStyle.getPropertyValue('--hero-space-between-mobile')
        );
        var heroSpaceBetweenTablet = parseFloat(
          heroComputedStyle.getPropertyValue('--hero-space-between-tablet')
        );

        if (isNaN(heroSpaceBetweenMobile)) heroSpaceBetweenMobile = 0;
        if (isNaN(heroSpaceBetweenTablet)) heroSpaceBetweenTablet = 0;

        var updateHeroIndicator = function(swiper) {
          var currentEl = heroEl.querySelector('.js-home-hero-current');
          var totalEl = heroEl.querySelector('.js-home-hero-total');
          var activeSlide = swiper.slides && swiper.slides[swiper.activeIndex];
          var logicalIndex = activeSlide
            ? parseInt(activeSlide.getAttribute('data-home-hero-index'), 10)
            : 0;

          if (isNaN(logicalIndex)) logicalIndex = 0;
          if (currentEl) currentEl.textContent = logicalIndex + 1;
          if (totalEl) totalEl.textContent = heroSlideCount;
        };

        // GEO 01. [접근성] 복제 수가 아닌 원본 배너의 논리 번호와 총수를 안내한다.
        var updateHeroSlideLabels = function(swiper) {
          Array.prototype.forEach.call(swiper.slides, function(slide) {
            var logicalIndex = parseInt(slide.getAttribute('data-home-hero-index'), 10);

            if (!isNaN(logicalIndex)) {
              slide.setAttribute('aria-label', (logicalIndex + 1) + ' / ' + heroSlideCount);
            }
          });
        };

        // GEO 01. [접근성] loop 슬라이드 중 화면 안에 완전히 보이는 배너만 Tab 포커스를 허용한다.
        var updateHeroAccessibility = function(swiper) {
          var carouselRect = swiper.el.getBoundingClientRect();

          Array.prototype.forEach.call(swiper.slides, function(slide) {
            var slideRect = slide.getBoundingClientRect();
            var isHidden = slideRect.width === 0
              || slideRect.left < carouselRect.left - 1
              || slideRect.right > carouselRect.right + 1;

            slide.toggleAttribute('inert', isHidden);
          });
        };

        // GEO 01. PC에서는 최종 위치의 가운데 3개를 제외한 모든 배너를 블러 처리한다.
        var updateHeroBlurState = function(swiper) {
          var slides = swiper.slides;
          var slideCount = slides ? slides.length : 0;

          if (!slideCount) return;

          var clearSlideIndices = [
            swiper.activeIndex % slideCount,
            (swiper.activeIndex + 1) % slideCount,
            (swiper.activeIndex + 2) % slideCount
          ];

          Array.prototype.forEach.call(slides, function(slide, slideIndex) {
            slide.classList.toggle(
              'is-edge-blurred',
              heroPcMedia.matches && clearSlideIndices.indexOf(slideIndex) === -1
            );
          });
        };

        options = {
          loop: heroSlideCount > 1,
          centeredSlides: true,
          slidesPerView: 'auto',
          spaceBetween: heroSpaceBetweenMobile,
          speed: 600,
          watchOverflow: true,
          a11y: { scrollOnFocus: false },
          autoplay: heroCanAutoplay
            ? { delay: 5000, disableOnInteraction: false }
            : false,
          navigation: {
            nextEl: '.js-home-hero-next',
            prevEl: '.js-home-hero-prev'
          },
          breakpoints: {
            768: { spaceBetween: heroSpaceBetweenTablet }
          },
          on: {
            init: function () {
              updateHeroIndicator(this);
              updateHeroSlideLabels(this);
              updateHeroAccessibility(this);
              updateHeroBlurState(this);

              if (!heroCanAutoplay) {
                var controlEl = heroEl.querySelector('.js-home-hero-control');
                if (controlEl) {
                  controlEl.classList.add('is-paused');
                  controlEl.setAttribute('aria-label', '자동 재생');
                }
              }
            },
            afterInit: function () {
              updateHeroSlideLabels(this);
              updateHeroBlurState(this);
              if (heroSectionEl) heroSectionEl.classList.remove('is-loading');
            },
            slideChange: function () {
              updateHeroIndicator(this);
            },
            beforeTransitionStart: function () {
              // 최종 activeIndex가 반영된 뒤 실제 이동이 시작되기 전에 상태를 교체한다.
              updateHeroBlurState(this);
            },
            transitionEnd: function () {
              updateHeroAccessibility(this);
              updateHeroBlurState(this);
            },
            resize: function () {
              updateHeroAccessibility(this);
              updateHeroBlurState(this);
            }
          }
        };
        break;
      case 'js-home-category-quick-mobile-carousel':
        var categoryQuickMobileEl = document.querySelector('.js-home-category-quick-mobile-carousel');
        var categoryQuickIndicatorEl = categoryQuickMobileEl
          ? categoryQuickMobileEl.querySelector('.js-home-category-quick-indicator')
          : null;

        options = {
          slidesPerView: 'auto',
          spaceBetween: 0,
          speed: 500,
          watchOverflow: false,
          setWrapperSize: true,
          simulateTouch: true,
          grabCursor: true,
          freeMode: {
            enabled: true,
            momentum: true,
            momentumBounce: false,
            sticky: false
          },
          // CSR-20551: GEO 03 모바일 카테고리의 현재 스크롤 위치 표시
          scrollbar: {
            el: categoryQuickIndicatorEl,
            draggable: false,
            hide: false,
            snapOnRelease: false
          }
        };
        break;
      case 'js-home-category-quick-carousel':
        var categoryQuickEl = document.querySelector('.js-home-category-quick-carousel');
        var categoryQuickSectionEl = categoryQuickEl
          ? categoryQuickEl.closest('.js-home-category-quick-menu')
          : null;
        var categoryQuickComputedStyle = categoryQuickEl
          ? window.getComputedStyle(categoryQuickEl)
          : null;
        var categoryQuickSpaceBetween = categoryQuickComputedStyle
          ? parseFloat(categoryQuickComputedStyle.getPropertyValue('--category-quick-space-between'))
          : 24;

        if (isNaN(categoryQuickSpaceBetween)) categoryQuickSpaceBetween = 24;

        options = {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          slidesPerGroupAuto: true,
          spaceBetween: categoryQuickSpaceBetween,
          speed: 500,
          watchOverflow: false,
          // GEO 03. [접근성] Swiper가 버튼의 한글 레이블을 영문 기본값으로 덮어쓰지 않도록 지정
          a11y: {
            prevSlideMessage: '이전 카테고리',
            nextSlideMessage: '다음 카테고리'
          },
          navigation: {
            nextEl: categoryQuickSectionEl
              ? categoryQuickSectionEl.querySelector('.js-home-category-quick-next')
              : null,
            prevEl: categoryQuickSectionEl
              ? categoryQuickSectionEl.querySelector('.js-home-category-quick-prev')
              : null
          }
        };
        break;
      case 'js-home-subscription-benefit-banner':
        var subscriptionBenefitBannerEl = document.querySelector('.js-home-subscription-benefit-banner');
        var subscriptionBenefitBannerSlides = subscriptionBenefitBannerEl
          ? subscriptionBenefitBannerEl.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide')
          : [];
        var subscriptionBenefitBannerCount = subscriptionBenefitBannerSlides.length;

        if (subscriptionBenefitBannerEl) {
          subscriptionBenefitBannerEl.classList.toggle('is-single', subscriptionBenefitBannerCount <= 1);
        }

        options = {
          slidesPerView: 1,
          spaceBetween: 10,
          speed: 500,
          watchOverflow: true,
          allowTouchMove: subscriptionBenefitBannerCount > 1,
          // GEO 05. [접근성] 배너 탐색 및 페이지네이션 상태를 스크린리더에 안내
          a11y: {
            prevSlideMessage: '이전 혜택 배너',
            nextSlideMessage: '다음 혜택 배너',
            paginationBulletMessage: '{{index}}번 혜택 배너로 이동'
          },
          pagination: {
            el: '.js-home-subscription-benefit-banner-pagination',
            clickable: true
          }
        };
        break;
      case 'js-home-resubscribe-contracts':
        var resubscribeContractsEl = document.querySelector('.js-home-resubscribe-contracts');
        var resubscribeSectionEl = resubscribeContractsEl
          ? resubscribeContractsEl.closest('.js-home-resubscribe-benefits')
          : null;
        var resubscribeContractCount = resubscribeContractsEl
          ? resubscribeContractsEl.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length
          : 0;

        if (resubscribeContractsEl) {
          resubscribeContractsEl.classList.toggle('is-single', resubscribeContractCount <= 1);
        }

        options = {
          slidesPerView: 'auto',
          spaceBetween: 8,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          speed: 500,
          watchOverflow: true,
          allowTouchMove: resubscribeContractCount > 1,
          // GEO 06. [접근성] 재구독 대상 제품 슬라이더의 이동 목적을 안내
          a11y: {
            prevSlideMessage: '이전 재구독 대상 제품',
            nextSlideMessage: '다음 재구독 대상 제품'
          },
          navigation: {
            nextEl: resubscribeSectionEl
              ? resubscribeSectionEl.querySelector('.js-home-resubscribe-contract-next')
              : null,
            prevEl: resubscribeSectionEl
              ? resubscribeSectionEl.querySelector('.js-home-resubscribe-contract-prev')
              : null
          },
          breakpoints: {
            1024: {
              slidesPerView: 2,
              spaceBetween: 16,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0
            }
          }
        };
        break;
      case 'js-home-resubscribe-products':
        var resubscribeProductsEl = document.querySelector('.js-home-resubscribe-products');
        var resubscribeProductsWrapEl = resubscribeProductsEl
          ? resubscribeProductsEl.closest('.js-home-resubscribe-products-wrap')
          : null;

        options = {
          slidesPerView: 'auto',
          spaceBetween: 10,
          speed: 500,
          watchOverflow: true,
          // GEO 06. [접근성] 추천 상품 슬라이더의 현재 위치와 이동 목적을 안내
          a11y: {
            prevSlideMessage: '이전 재구독 추천 상품',
            nextSlideMessage: '다음 재구독 추천 상품'
          },
          navigation: {
            nextEl: resubscribeProductsWrapEl
              ? resubscribeProductsWrapEl.querySelector('.js-home-resubscribe-products-next')
              : null,
            prevEl: resubscribeProductsWrapEl
              ? resubscribeProductsWrapEl.querySelector('.js-home-resubscribe-products-prev')
              : null
          },
          scrollbar: {
            el: resubscribeProductsWrapEl
              ? resubscribeProductsWrapEl.querySelector('.js-home-resubscribe-products-scrollbar')
              : null,
            draggable: true,
            dragSize: 40,
            snapOnRelease: true
          },
          breakpoints: {
            1024: {
              slidesPerView: 5,
              slidesPerGroup: 5,
              spaceBetween: 24,
              roundLengths: true // 정수 픽셀로 계산
            }
          }
        };
        break;
      case 'js-home-best-ranking-categories':
        var bestRankingSectionEl = document.querySelector('.js-home-best-ranking');
        var bestRankingCategoriesEl = carouselEl || document.querySelector('.js-home-best-ranking-categories');
        var updateBestRankingCategoryEdges = function(swiper) {
          if (!swiper || !swiper.el) return;

          swiper.el.classList.toggle('has-prev-items', !swiper.isBeginning);
          swiper.el.classList.toggle('has-next-items', !swiper.isEnd);
        };

        if (window.innerWidth < 1024) {
          if (bestRankingCategoriesEl) {
            bestRankingCategoriesEl.classList.remove('has-prev-items', 'has-next-items');
          }

          options = {
            slidesPerView: 'auto',
            spaceBetween: 8,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 36,
            speed: 400,
            watchOverflow: true,
            watchSlidesProgress: true,
            freeMode: {
              enabled: true,
              sticky: false
            }
          };
          break;
        }

        options = {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          slidesPerGroupAuto: true,
          spaceBetween: 22,
          speed: 500,
          watchOverflow: true,
          a11y: {
            prevSlideMessage: '이전 구독 카테고리',
            nextSlideMessage: '다음 구독 카테고리'
          },
          navigation: {
            nextEl: bestRankingSectionEl
              ? bestRankingSectionEl.querySelector('.js-home-best-ranking-category-next')
              : null,
            prevEl: bestRankingSectionEl
              ? bestRankingSectionEl.querySelector('.js-home-best-ranking-category-prev')
              : null
          },
          on: {
            init: function() {
              updateBestRankingCategoryEdges(this);
            },
            slideChange: function() {
              updateBestRankingCategoryEdges(this);
            },
            resize: function() {
              updateBestRankingCategoryEdges(this);
            },
            update: function() {
              updateBestRankingCategoryEdges(this);
            }
          }
        };
        break;
      case 'js-home-best-ranking-products':
        var bestRankingProductsSectionEl = document.querySelector('.js-home-best-ranking');
        options = {
          slidesPerView: 4,
          slidesPerGroup: 4,
          slidesPerColumn: 1,
          slidesPerColumnFill: 'row',
          grid: {
            rows: 1,
            fill: 'row'
          },
          spaceBetween: 24,
          speed: 500,
          watchOverflow: true,
          a11y: {
            prevSlideMessage: '이전 베스트 랭킹 상품',
            nextSlideMessage: '다음 베스트 랭킹 상품'
          },
          navigation: {
            nextEl: bestRankingProductsSectionEl
              ? bestRankingProductsSectionEl.querySelector('.js-home-best-ranking-next')
              : null,
            prevEl: bestRankingProductsSectionEl
              ? bestRankingProductsSectionEl.querySelector('.js-home-best-ranking-prev')
              : null
          },
          scrollbar: {
            el: bestRankingProductsSectionEl
              ? bestRankingProductsSectionEl.querySelector('.js-home-best-ranking-scrollbar')
              : null,
            draggable: true,
            dragSize: 40,
            snapOnRelease: true
          }
        };
        break;
      case 'js-home-season-promotion-swiper':
        var seasonPromotionProductsWrapEl = carouselEl
          ? carouselEl.closest('.careSolutions__season-promotion-products-wrap')
          : document.querySelector('.careSolutions__season-promotion-products-wrap');
        options = {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          slidesPerGroupAuto: true,
          spaceBetween: 12,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          speed: 500,
          watchOverflow: true,
          a11y: {
            prevSlideMessage: '이전 시즌 프로모션 상품',
            nextSlideMessage: '다음 시즌 프로모션 상품'
          },
          navigation: {
            nextEl: seasonPromotionProductsWrapEl
              ? seasonPromotionProductsWrapEl.querySelector('.js-home-season-promotion-next')
              : null,
            prevEl: seasonPromotionProductsWrapEl
              ? seasonPromotionProductsWrapEl.querySelector('.js-home-season-promotion-prev')
              : null
          },
          scrollbar: {
            el: seasonPromotionProductsWrapEl
              ? seasonPromotionProductsWrapEl.querySelector('.js-home-season-promotion-scrollbar')
              : null,
            draggable: true,
            dragSize: 40,
            snapOnRelease: true
          },
          breakpoints: {
            1024: {
              spaceBetween: 20,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0
            }
          }
        };
        break;
      case 'js-home-subscription-reasons-swiper':
        options = {
          slidesPerView: 'auto',
          spaceBetween: 20,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          speed: 500,
          watchOverflow: true,
          a11y: {
            prevSlideMessage: '이전 구독 장점',
            nextSlideMessage: '다음 구독 장점'
          },
          breakpoints: {
            1024: {
              spaceBetween: 20,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0
            }
          }
        };
        break;
      case 'js-home-expert-care-swiper':
        options = {
          slidesPerView: 'auto',
          spaceBetween: 20,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          speed: 500,
          autoHeight: true,
          watchOverflow: true,
          a11y: {
            prevSlideMessage: '이전 방문케어 전후 비교',
            nextSlideMessage: '다음 방문케어 전후 비교'
          },
          on: {
            init: function() {
              subscriptionHomeUI.syncExpertCareSlideState(this);
            },
            slideChange: function() {
              var $section = $(this.el).closest('.js-home-expert-care-highlight');
              var $categories = $section.find('.careSolutions__expert-care-highlight-categories');
              var $slide = $(this.slides[this.activeIndex]);
              var category = $slide.attr('data-expert-care-category');

              $section.find('.js-home-expert-care-category')
                .removeClass('is-active')
                .attr('aria-pressed', 'false');
              $section.find('.js-home-expert-care-category[data-expert-care-category="' + category + '"]')
                .addClass('is-active')
                .attr('aria-pressed', 'true');
              $section.attr('data-active-category', category);
              subscriptionHomeUI.syncExpertCareSlideState(this);

              // 선택 상태가 반영된 다음 카테고리를 정중앙으로 부드럽게 이동한다.
              requestAnimationFrame(function() {
                subscriptionHomeUI.centerActiveTab(
                  $categories,
                  true,
                  '.js-home-expert-care-category.is-active',
                  0
                );
              });
            }
          }
        };
        break;
      case 'js-home-subscription-guide-categories':
        var subscriptionGuideCategorySectionEl = document.querySelector('.js-home-subscription-guide');

        if (window.innerWidth < 1024) {
          options = {
            slidesPerView: 'auto',
            spaceBetween: 8,
            slidesOffsetBefore: 20,
            slidesOffsetAfter: 20,
            speed: 400,
            watchOverflow: true,
            watchSlidesProgress: true,
            freeMode: {
              enabled: true,
              sticky: false
            }
          };
          break;
        }

        options = {
          slidesPerView: 'auto',
          spaceBetween: 8,
          speed: 400,
          watchOverflow: true,
          a11y: {
            prevSlideMessage: '이전 구독 가이드 카테고리',
            nextSlideMessage: '다음 구독 가이드 카테고리'
          },
          navigation: {
            nextEl: subscriptionGuideCategorySectionEl
              ? subscriptionGuideCategorySectionEl.querySelector('.js-home-subscription-guide-category-next')
              : null,
            prevEl: subscriptionGuideCategorySectionEl
              ? subscriptionGuideCategorySectionEl.querySelector('.js-home-subscription-guide-category-prev')
              : null
          }
        };
        break;
      case 'js-home-subscription-guide-swiper':
        var subscriptionGuideSectionEl = document.querySelector('.js-home-subscription-guide');
        options = {
          slidesPerView: 'auto',
          slidesPerGroup: 1,
          spaceBetween: 12,
          slidesOffsetBefore: 20,
          slidesOffsetAfter: 20,
          speed: 500,
          watchOverflow: true,
          watchSlidesProgress: true,
          a11y: {
            prevSlideMessage: '이전 구독 가이드',
            nextSlideMessage: '다음 구독 가이드'
          },
          navigation: {
            nextEl: subscriptionGuideSectionEl
              ? subscriptionGuideSectionEl.querySelector('.js-home-subscription-guide-next')
              : null,
            prevEl: subscriptionGuideSectionEl
              ? subscriptionGuideSectionEl.querySelector('.js-home-subscription-guide-prev')
              : null
          },
          scrollbar: {
            el: subscriptionGuideSectionEl
              ? subscriptionGuideSectionEl.querySelector('.js-home-subscription-guide-scrollbar')
              : null,
            draggable: true,
            dragSize: 40,
            snapOnRelease: true
          },
          breakpoints: {
            1024: {
              slidesPerGroup: 4,
              spaceBetween: 24,
              slidesOffsetBefore: 0,
              slidesOffsetAfter: 0
            }
          },
          on: {
            init: function() {
              subscriptionHomeUI.syncSubscriptionGuideSlideState(this);
            },
            slideChange: function() {
              subscriptionHomeUI.syncSubscriptionGuideSlideState(this);
            },
            resize: function() {
              subscriptionHomeUI.syncSubscriptionGuideSlideState(this);
            },
            transitionEnd: function() {
              subscriptionHomeUI.syncSubscriptionGuideSlideState(this);
            }
          }
        };
        break;
    }
    return options;
  },

  // GEO 공통. 데이터 렌더링 완료 후 호출하는 개별 Swiper 재설정 API
  reinitSwiper: function(carouselClass) {
    if (typeof Swiper === 'undefined') return;

    var self = this;

    // 기존 활성화된 인스턴스가 존재하면 메모리 누수 방지를 위해 해제(destroy) 후 삭제
    if (self.swipers[carouselClass]) {
      if (Array.isArray(self.swipers[carouselClass])) {
        self.swipers[carouselClass].forEach(function(swiper) {
          swiper.destroy(true, true);
        });
      } else {
        self.swipers[carouselClass].destroy(true, true);
      }
      delete self.swipers[carouselClass];
    }

    var el = document.querySelector('.' + carouselClass);
    if (el) {
      // GEO 03. 카테고리 퀵메뉴의 내부 1행 Swiper는 PC에서만 사용
      if (carouselClass === 'js-home-category-quick-carousel' && window.innerWidth < 1024) {
        return;
      }
      // GEO 03. 카테고리 퀵메뉴의 외부 freeMode Swiper는 MO에서만 사용
      if (carouselClass === 'js-home-category-quick-mobile-carousel' && window.innerWidth >= 1024) {
        return;
      }
      // GEO 07. 베스트 랭킹 상품은 모바일에서 3열 2행 정적 목록으로 사용
      if (carouselClass === 'js-home-best-ranking-products' && window.innerWidth < 1024) {
        return;
      }
      // GEO 10. 전문가 방문케어 카드는 PC에서 2열 정적 목록으로 사용
      if (carouselClass === 'js-home-expert-care-swiper' && window.innerWidth >= 1024) {
        self.syncExpertCareSlideState(null);
        return;
      }
      if (
        carouselClass === 'js-home-best-ranking-categories' ||
        carouselClass === 'js-home-subscription-guide-categories'
      ) {
        self.syncCategorySwiper(carouselClass, el);
        if (self.updateTabOverflow) self.updateTabOverflow();
      } else if (carouselClass === 'js-home-season-promotion-swiper') {
        var seasonPromotionEls = document.querySelectorAll('.' + carouselClass);
        self.swipers[carouselClass] = [];

        Array.prototype.forEach.call(seasonPromotionEls, function(seasonPromotionEl) {
          var seasonPromotionOptions = self.getSwiperOptions(carouselClass, seasonPromotionEl);
          self.swipers[carouselClass].push(new Swiper(seasonPromotionEl, seasonPromotionOptions));
        });
      } else {
        var options = self.getSwiperOptions(carouselClass);
        var swiper = new Swiper(el, options);
        self.swipers[carouselClass] = swiper;

        // CSR-19487: GEO12 필터 변경 후 재생성된 Swiper의 인디케이터 상태를 동기화한다.
        if (carouselClass === 'js-home-subscription-guide-swiper') {
          requestAnimationFrame(function() {
            if (!swiper || swiper.destroyed) return;

            swiper.update();
            swiper.slideTo(0, 0, false);

            if (swiper.navigation && swiper.navigation.update) {
              swiper.navigation.update();
            }

            if (swiper.scrollbar) {
              swiper.scrollbar.updateSize();
              swiper.scrollbar.setTranslate();
            }

            self.syncSubscriptionGuideSlideState(swiper);
          });
        }
      }
    }
  },

  // GEO 공통. 데이터 일괄 렌더링 완료 후 호출하는 전체 Swiper 재설정 API
  reinitAllSwipers: function() {
    var self = this;
    var carousels = [
      'js-home-hero-carousel',
      'js-home-category-quick-mobile-carousel',
      'js-home-category-quick-carousel',
      'js-home-subscription-benefit-banner',
      'js-home-resubscribe-contracts',
      'js-home-resubscribe-products',
      'js-home-best-ranking-categories',
      'js-home-best-ranking-products',
      'js-home-season-promotion-swiper',
      'js-home-subscription-reasons-swiper',
      'js-home-expert-care-swiper',
      'js-home-subscription-guide-categories',
      'js-home-subscription-guide-swiper'
    ];
    
    carousels.forEach(function(carouselClass) {
      self.reinitSwiper(carouselClass);
    });
  },

  // GEO 01·07·13. 레이아웃 토글 제어
  initLayoutToggles: function() {
    var self = this;

    // GEO 07. MO 카테고리 목록 더보기/접기
    $(document).on(
      'click',
      '.js-home-best-ranking-tab-container .js-home-tabs-toggle',
      function() {
        var $btn = $(this);
        var swiperClass = 'js-home-best-ranking-categories';
        var swiperSelector = '.' + swiperClass;
        var $container = $btn.closest('.js-home-best-ranking-tab-container');
        var $tabs = $container.find('.js-home-best-ranking-tabs');
        var isCollapsed = $tabs.hasClass('is-collapsed');

        if (isCollapsed) {
          $tabs.removeClass('is-collapsed').addClass('is-expanded');
          $container.addClass('is-expanded');
          $btn
            .addClass('is-active')
            .attr({ 'aria-expanded': 'true', 'aria-label': '카테고리 목록 닫기' });
          self.destroyCategorySwiper(swiperClass);
        } else {
          $tabs.removeClass('is-expanded').addClass('is-collapsed');
          $container.removeClass('is-expanded');
          $btn
            .removeClass('is-active')
            .attr({ 'aria-expanded': 'false', 'aria-label': '카테고리 목록 열기' });
          self.syncCategorySwiper(swiperClass, $container.find(swiperSelector)[0]);
          self.centerActiveTab($tabs, false, '.js-home-best-ranking-category.is-active', 20);
        }
      }
    );

    // GEO 13. 자주 묻는 질문 - 한 번에 하나만 열리는 아코디언
    $(document).on('click', '.js-home-faq .js-home-faq-question', function () {
      var $question = $(this);
      var $item = $question.closest('.js-home-faq-item');
      var $block = $question.closest('.js-home-faq-panel');
      var isOpen = $item.hasClass('is-open');

      // 같은 블록 내의 다른 질문들은 모두 닫음
      $block.find('.js-home-faq-item').not($item).each(function () {
        var $otherItem = $(this);
        $otherItem.removeClass('is-open');
        $otherItem.find('.js-home-faq-question').attr('aria-expanded', 'false');
        $otherItem.find('.js-home-faq-answer')
          .attr('aria-hidden', 'true')
          .css('max-height', '');
      });

      if (isOpen) {
        $item.removeClass('is-open');
        $question.attr('aria-expanded', 'false');
        $item.find('.js-home-faq-answer').attr('aria-hidden', 'true');
        $item.find('.js-home-faq-answer').css('max-height', '');
      } else {
        $item.addClass('is-open');
        $question.attr('aria-expanded', 'true');
        var $answer = $item.find('.js-home-faq-answer');
        if ($answer.length) {
          $answer.attr('aria-hidden', 'false');
          $answer.css('max-height', $answer[0].scrollHeight + 'px');
        }
      }
    });

    // GEO 01. 히어로 배너 - 재생/일시정지
    $(document).on('click', '.js-home-hero-carousel .js-home-hero-control', function() {
      var heroSwiper = self.swipers['js-home-hero-carousel'];
      if (heroSwiper && heroSwiper.autoplay) {
        var $btn = $(this);
        if (heroSwiper.autoplay.running) {
          heroSwiper.autoplay.stop();
          $btn.addClass('is-paused');
          $btn.attr('aria-label', '자동 재생');
        } else {
          heroSwiper.autoplay.start();
          $btn.removeClass('is-paused');
          $btn.attr('aria-label', '일시정지');
        }
      }
    });
  },

  // GEO 07. MO 카테고리가 한 줄을 초과하면 토글 버튼을 노출한다.
  initTabOverflow: function() {
    var self = this;

    var tabConfigs = [
      {
        container: '.js-home-best-ranking-tab-container',
        tabs: '.js-home-best-ranking-tabs',
        toggle: '.js-home-tabs-toggle',
        category: '.js-home-best-ranking-category',
        swiper: 'js-home-best-ranking-categories',
        deferredGroup: 'geo07'
      }
    ];

    function resetTabState($container, $tabs, $toggle) {
      $container.removeClass('is-expanded');
      $tabs.removeClass('is-expanded').addClass('is-collapsed');
      $toggle
        .removeClass('is-active')
        .attr({ 'aria-expanded': 'false', 'aria-label': '카테고리 목록 열기' });
    }

    function updateOverflow() {
      tabConfigs.forEach(function(config) {
        $(config.container).each(function() {
          var $container = $(this);
          var $tabs = $container.find(config.tabs);
          if (!$tabs.length) return;

          var $toggle = $container.find(config.toggle);

          if (window.innerWidth >= 1024) {
            $container.removeClass('has-overflow');
            resetTabState($container, $tabs, $toggle);
            if (self.deferredSwiperGroups[config.deferredGroup]) {
              self.syncCategorySwiper(config.swiper, $container.find('.' + config.swiper)[0]);
            }
            return;
          }

          var $btnTabs = $tabs.find(config.category);
          if (!$btnTabs.length) return;

          var totalWidthWithGap = 0;
          var gap = 8;
          $btnTabs.each(function(index) {
            totalWidthWithGap += $(this).outerWidth();
            if (index < $btnTabs.length - 1) {
              totalWidthWithGap += gap;
            }
          });

          var containerWidth = $container[0].clientWidth;
          var toggleBtnWidth = 36;

          if (totalWidthWithGap + toggleBtnWidth > containerWidth + 1) {
            $container.addClass('has-overflow');
          } else {
            $container.removeClass('has-overflow');
            resetTabState($container, $tabs, $toggle);
            if (self.deferredSwiperGroups[config.deferredGroup]) {
              self.syncCategorySwiper(config.swiper, $container.find('.' + config.swiper)[0]);
            }
          }
        });
      });
    }

    // 최초 실행 및 로드/리사이즈 이벤트 바인딩
    updateOverflow();
    $(window).on('load', function() {
      updateOverflow();
    });
    $(window).on('resize', function() {
      updateOverflow();
    });

    // 외부 수동 호출을 위해 함수 등록
    self.updateTabOverflow = updateOverflow;
  },

  // GEO 06·07·10~13. 활성 탭을 가로 스크롤 영역의 가운데로 이동
  centerActiveTab: function($tabContainer, isSmooth, activeButtonSelector, centerOffset) {
    if (!$tabContainer || !$tabContainer.length || !activeButtonSelector) return;
    centerOffset = typeof centerOffset === 'number' ? centerOffset : 0;
    var container = $tabContainer[0];
    var $activeBtn = $tabContainer.find(activeButtonSelector);
    if (!$activeBtn.length) return;
    var btn = $activeBtn[0];

    // Swiper는 현재 translate를 기준으로 활성 카테고리를 영역 중앙에 배치한다.
    var swiperEl = $tabContainer.closest('.swiper')[0];
    var swiper = swiperEl ? swiperEl.swiper : null;
    if (swiper && !swiper.destroyed) {
      var swiperRect = swiperEl.getBoundingClientRect();
      var activeRect = btn.getBoundingClientRect();
      var desiredCenter = swiperRect.left + (swiperEl.clientWidth / 2) - centerOffset;
      var currentTranslate = swiper.getTranslate();
      var targetTranslate = currentTranslate + desiredCenter - (activeRect.left + (activeRect.width / 2));

      targetTranslate = Math.min(
        swiper.minTranslate(),
        Math.max(swiper.maxTranslate(), targetTranslate)
      );
      swiper.translateTo(targetTranslate, isSmooth ? 300 : 0, true, true);
      return;
    }

    if (container && btn) {
      var containerRect = container.getBoundingClientRect();
      var btnRect = btn.getBoundingClientRect();
      var containerWidth = container.clientWidth;
      var btnCenter = container.scrollLeft + (btnRect.left - containerRect.left) + (btnRect.width / 2);
      
      var targetScrollLeft = btnCenter - (containerWidth / 2) + centerOffset;

      if (isSmooth) {
        // 네이티브 smooth scroll이 모션 설정에 따라 생략되지 않도록 이동 시간을 직접 제어한다.
        $(container).stop(true).animate({ scrollLeft: targetScrollLeft }, 150);
      } else {
        container.scrollLeft = targetScrollLeft;
      }
    }
  },

  // GEO 11. 모바일 추천 카테고리의 실제 sticky 상태를 클래스와 동기화한다.
  initPersonalizedRecommendationSticky: function() {
    var $categories = $('.careSolutions__personalized-recommendation-categories');
    var mobileHeaderHeight = 46;
    var isTicking = false;

    if (!$categories.length) return;

    function updateStickyState() {
      isTicking = false;

      $categories.each(function() {
        var $category = $(this);

        if (window.innerWidth >= 768) {
          $category.removeClass('is-sticky');
          return;
        }

        var categoryTop = this.getBoundingClientRect().top;
        var isSticky = Math.abs(categoryTop - mobileHeaderHeight) <= 1;

        $category.toggleClass('is-sticky', isSticky);
      });
    }

    function requestStickyUpdate() {
      if (isTicking) return;

      isTicking = true;
      requestAnimationFrame(updateStickyState);
    }

    updateStickyState();

    $(window)
      .off('.homePersonalizedRecommendationSticky')
      .on('scroll.homePersonalizedRecommendationSticky resize.homePersonalizedRecommendationSticky', requestStickyUpdate);
  },

  // GEO 06·07·10~13. 카테고리 전환 및 렌더링 연동
  initTabSwitchers: function() {
    var self = this;

    // GEO 06. 카테고리 선택 UI만 관리하고 데이터 처리는 외부에 위임한다.
    $(document).on('click', '.js-home-resubscribe-category', function() {
      var $btn = $(this);
      var $section = $btn.closest('.js-home-resubscribe-benefits');
      var $tabs = $section.find('.careSolutions__resubscribe-benefits-tabs');
      var category = $btn.attr('data-resubscribe-category');

      // 선택 상태가 반영된 다음 비-Swiper 카테고리를 정중앙으로 부드럽게 이동한다.
      requestAnimationFrame(function() {
        self.centerActiveTab($tabs, true, '.js-home-resubscribe-category.is-active', 0);
      });

      if ($btn.hasClass('is-active')) return;

      $section.find('.js-home-resubscribe-category')
        .removeClass('is-active')
        .attr('aria-pressed', 'false');
      $btn.addClass('is-active').attr('aria-pressed', 'true');
      $section.attr('data-active-category', category);

      $section.trigger('careSolutions:resubscribeCategoryChange', [{
        category: category
      }]);
    });

    // GEO 07. 카테고리 선택 UI를 MO/PC에서 동일하게 관리한다.
    $(document).on('click', '.js-home-best-ranking-category', function() {
      var $btn = $(this);
      var $section = $btn.closest('.js-home-best-ranking');
      var $tabs = $section.find('.js-home-best-ranking-tabs');
      var $container = $section.find('.js-home-best-ranking-tab-container');
      var category = $btn.attr('data-best-ranking-category');

      if ($btn.hasClass('is-active')) return;

      $section.find('.js-home-best-ranking-category')
        .removeClass('is-active')
        .attr('aria-pressed', 'false');
      $btn.addClass('is-active').attr('aria-pressed', 'true');
      $section.attr('data-active-category', category);

      if (window.innerWidth < 1024 && !$container.hasClass('is-expanded')) {
        // 접기 버튼과 그라데이션 영역을 고려해 중앙 위치를 20px 보정한다.
        self.centerActiveTab($tabs, true, '.js-home-best-ranking-category.is-active', 20);
      }

      $section.trigger('careSolutions:bestRankingCategoryChange', [{
        category: category
      }]);
    });

    // GEO 13. 선택 UI만 관리하고 데이터 요청과 렌더링은 변경 이벤트에 위임한다.
    $(document).on('click', '.js-home-faq-tab', function() {
      var $btn = $(this);
      var $section = $btn.closest('.js-home-faq');
      var $tabs = $section.find('.careSolutions__faq-tabs');
      var category = $btn.attr('data-faq-category');

      // 선택 상태가 반영된 다음 비-Swiper 카테고리를 정중앙으로 부드럽게 이동한다.
      requestAnimationFrame(function() {
        self.centerActiveTab($tabs, true, '.js-home-faq-tab.is-active', 0);
      });

      if ($btn.hasClass('is-active')) return;

      $section.find('.js-home-faq-tab')
        .removeClass('is-active')
        .attr('aria-pressed', 'false');
      $btn.addClass('is-active').attr('aria-pressed', 'true');
      $section.attr('data-active-category', category);

      $section.trigger('careSolutions:faqCategoryChange', [{
        category: category
      }]);
    });

    // GEO 11. 카테고리 선택 UI만 관리하고 상품 데이터 처리는 외부에 위임한다.
    $(document).on('click', '.js-home-personalized-recommendation-category', function() {
      var $btn = $(this);
      var $section = $btn.closest('.js-home-personalized-recommendation');
      var $categories = $section.find('.careSolutions__personalized-recommendation-categories');
      var category = $btn.attr('data-personalized-recommendation-category');

      // 선택 상태가 반영된 다음 활성 탭을 가운데로 이동하고, MO에서는 탭 줄을 헤더 아래에 맞춘다.
      requestAnimationFrame(function() {
        self.centerActiveTab($categories, true, '.js-home-personalized-recommendation-category.is-active', 0);

        if (window.innerWidth < 768 && $categories.length) {
          var mobileHeaderHeight = 46;
          var $categoryHeader = $section.find('.careSolutions__personalized-recommendation-header');
          var categoryMarginTop = parseFloat($categories.css('margin-top')) || 0;
          // sticky 중에도 위치가 변하지 않는 제목 영역을 기준으로 탭의 원래 문서 위치를 구한다.
          var categoryDocumentTop = $categoryHeader.offset().top + $categoryHeader.outerHeight() + categoryMarginTop;

          $('html, body').stop(true).animate({
            scrollTop: Math.max(0, categoryDocumentTop - mobileHeaderHeight)
          }, 150);
        }
      });

      if ($btn.hasClass('is-active')) return;

      $section.find('.js-home-personalized-recommendation-category')
        .removeClass('is-active')
        .attr('aria-pressed', 'false');
      $btn.addClass('is-active').attr('aria-pressed', 'true');
      $section.attr('data-active-category', category);

      $section.trigger('careSolutions:personalizedRecommendationCategoryChange', [{
        category: category
      }]);
    });

    // GEO 12. 카테고리 선택 UI만 관리하고 데이터 처리는 외부에 위임한다.
    $(document).on('click', '.js-home-subscription-guide-category', function() {
      var $btn = $(this);
      var $section = $btn.closest('.js-home-subscription-guide');
      var $categories = $section.find('.careSolutions__subscription-guide-categories');
      var category = $btn.attr('data-subscription-guide-category');

      // 선택 상태가 반영된 다음 Swiper 카테고리를 정중앙으로 부드럽게 이동한다.
      requestAnimationFrame(function() {
        self.centerActiveTab($categories, true, '.js-home-subscription-guide-category.is-active', 0);
      });

      if ($btn.hasClass('is-active')) return;

      $section.find('.js-home-subscription-guide-category')
        .removeClass('is-active')
        .attr('aria-pressed', 'false');
      $btn.addClass('is-active').attr('aria-pressed', 'true');
      $section.attr('data-active-category', category);

      $section.trigger('careSolutions:subscriptionGuideCategoryChange', [{
        category: category
      }]);
    });

    // GEO 10. 카테고리와 모바일 카드 위치를 동기화한다.
    $(document).on('click', '.js-home-expert-care-category', function() {
      var $btn = $(this);
      var $section = $btn.closest('.js-home-expert-care-highlight');
      var category = $btn.attr('data-expert-care-category');
      var slideIndex = parseInt($btn.attr('data-slide-index'), 10);
      var swiper = self.swipers['js-home-expert-care-swiper'];

      $section.find('.js-home-expert-care-category')
        .removeClass('is-active')
        .attr('aria-pressed', 'false');
      $btn.addClass('is-active').attr('aria-pressed', 'true');
      $section.attr('data-active-category', category);

      if (swiper && !isNaN(slideIndex)) {
        swiper.slideTo(slideIndex);
      } else {
        // Swiper가 없는 상태에서도 선택한 카테고리의 중앙 정렬을 유지한다.
        requestAnimationFrame(function() {
          self.centerActiveTab(
            $section.find('.careSolutions__expert-care-highlight-categories'),
            true,
            '.js-home-expert-care-category.is-active',
            0
          );
        });
      }
    });

  },

};

// GEO 공통. 외부 스크립트에서 사용할 수 있도록 전역 공개
window.subscriptionHomeUI = subscriptionHomeUI;

$(document).ready(function() {
  subscriptionHomeUI.init();
});
